import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import './User.css'; // Import CSS file for styles

const SignUp = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: ''
  });
  const [message , setMessage] = useState('');
  const [err , setErr] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleCheckboxChange = (e) => {
    setTermsAccepted(e.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!termsAccepted) {
      setErr('Please accept the terms and services');
      return;
    }

    try {
      const response = await axios.post('https://quickreact.onrender.com/signup', formData);
      setMessage(response.data.message);

      if (response.status === 201) {
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (error) {
      console.error(error);
      setErr('Failed to sign up Email already exist');
    }
  };

  return (
    <div className="signup-container">
      <div id="loginc">
        <div className="login-cont">
          <div className="head">
            <h1>Sign Up</h1>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="inputs">
              <div className="input-email">
                <label className="label" htmlFor="username">Username</label>
                <br />
                <input
                  type="text"
                  id="username"
                  name="username"
                  required
                  value={formData.username}
                  onChange={handleChange}
                  className="input"
                />
              </div>
              <div className="input-email">
                <label className="label" htmlFor="email">Email</label>
                <br />
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="input"
                />
              </div>
              <div className="input-password">
                <label className="label" htmlFor="password">Password</label>
                <br />
                <input
                  type="password"
                  id="password"
                  name="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                  className="input"
                />
              </div>
              <div className="remember-me">
                <input
                  type="checkbox"
                  id="checkbox"
                  checked={termsAccepted}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="checkbox">I accept the <Link to="/terms" >terms and services</Link></label>
              </div>
              {message && <div className="message">{message}</div>}
              {err && <div className="err">{err}</div>}
            </div>
            <div className="check-btn">
              <button type="submit" className="button2">Sign Up</button>
              <Link to="/login">Already Have an account?</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
